module.exports = __webpack_public_path__ + "media/images/admin/icons/alert-octagon-f82bb36345862489591b5703b0bff63b.svg";